import { StyleSheet } from 'react-native'

import themes from '../../../global/themes'
const { palette, typography } = themes.default

const styles = StyleSheet.create({
  desc: {
    height: '100%',
    padding: 5,
  },
  today: {
    color: palette.green,
    fontSize: typography.starFontSize - 1,
    fontWeight: '600',
    marginVertical: 1,
  },
  name: {
    color: palette.text.default,
    fontWeight: '600',
    marginVertical: 2,
  },
  default: {
    color: palette.text.default,
    fontSize: typography.starFontSize,
  },
  canvas: {
    position: 'absolute',
    left: 0,
    top: 0,
    right: 0,
    bottom: 0,
    width: '100%',
    height: '100%',
  },
})
export default styles
